import { Outlet } from "react-router-dom";
import "./Main.style.css";
import AppBarHorizontal from "../Main/Components/AppBarHorizontal/AppBarHorizontal";
import AppBarVertical from "../Main/Components/AppBarVertical/AppBarVertical";
import Footer from "../Main/Components/Footer/Footer";  
import Box from '@mui/material/Box';

const Main = () => {
  return (
    <div className="Main">
      <AppBarHorizontal />
      <div className="Main__div--container">
      <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
      <AppBarVertical />
      </Box>
       <div className="Main__div--Outlet">
       <Outlet />
       </div>
      </div>
      <Footer />
     
    </div>
  );
}
export default Main;